<template>
<div class="content" style="padding-bottom: 0;">
    <Header></Header>
    <div class="info mt30 crfff spin-content">
      <div class="back" @click="back" style="">
        <img width="70" src="../../static/images/back.png" />
        <span class="fs50 w-title ac">{{$t('luckySpin')}}</span>
      </div>
      <div class="box-lottery mt50">
        <i class="jian"></i>
        <div class="lottery-wrap" :style="wrapStyle">
          <span
            v-for="(item, index) in lotteryItems"
            :key="item.id"
            :class="'lottery-span' + (index + 1)"
            :data-id="item.id"
          >
            <i>{{item.name}}</i>
          </span>
        </div>
        <a class="lottery-btn" href="javascript:void(0);" @click="startLottery">
          <span style="color:#fff;position: relative;font-weight: 700;z-index: 1000;text-align: center;display: flex;justify-content: center;align-items: center;height: 161px;font-size: 40px;">{{$t('spin')}}</span>
        </a>
      </div>
      <div class="ac" style="margin-top: -180px;"><img src="../../static/images/bg_lottery_b.png"></div>
      <div class="buypin" >
        {{pinNum}}
      </div>
      <div class="ac" style="margin-top: -20px;text-shadow: 1px 3px 0px #000;">{{$t('SpinChances')}}</div>
    </div>
    <div class="winlist winlist-box" :class="{'active':isShow}">
      <div class="bg" v-if="isShow"></div>
      <div class="winlist-c">
        <div class="nav ac" style="margin-bottom: 70px;" v-if="isShow">{{$t('WinnerList')}}</div>
        <div class="up ac" :class="{'spin-down':isShow}" @click="getUp"><img src="../../static/images/up.png"></div>
        <div class="winlist-bg">
          <div class="disflex win-title" style="justify-content: space-between;">
            <span>{{$t('date')}}</span>
            <span>{{$t('phoneNumber')}}</span>
            <span>{{$t('Prizes')}}</span>
          </div>
          <div class="prize-content">
            <div class="prize-list disflex" v-for="(item,index) in prizeList" :key="index">
              <div class="">{{item.date}}</div>
              <div class="">{{item.mobile}}</div>
              <div class="">{{item.prize_name}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Dialog ref="saveDialog" title="" type="alert" :modalFoot="modalFoot" :bgC="modalFoot" :cancelText="$t('No')">
      <div slot="mdBox">
        <div class="spin-c ac disflex fs33">
          <div class="" style="width: 100%;">

            <div v-if="jiang=='none'" style="margin: 30px 0;">{{$t('tks')}}</div>
            <div v-else>
              <div  class="fs40">{{$t('Congratulations')}}</div>
<!--              <div class="">{{$t('spinTips1')}}</div>-->
              <div class="jiang">{{jiang}}</div>
            </div>
            <div>
              <img src="static/images/jiang.png" />
            </div>
            <div class="modal-footer ac">
              <button class="btn btn-yellow" id="closeModal" @click="confirm">{{$t('Confirm')}}</button>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
    <Dialog ref="buyDialog" title="" type="alert" :modalFoot="modalFoot" :bgC="modalFoot" :cancelText="$t('No')">
      <div slot="mdBox">
        <div class="spin-c ac fs33">
          <svg viewBox="0 0 300 150" xmlns="http://www.w3.org/2000/svg" style="margin-top: -80px;margin-bottom: -100px;">
            <filter id="shadow">
              <feDropShadow dx="1" dy="3" stdDeviation="0" flood-color="#000" />
            </filter>
            <path id="curve" d="M 50 140 A 140 140 0 0 1 260 140" fill="transparent" />
            <text class="" filter="url(#shadow)" font-size="20px" fill="#fff">
              <textPath href="#curve" startOffset="50%" text-anchor="middle">
                {{$t('Congratulations')}}
              </textPath>
            </text>
          </svg>
          <div>
            <div class="" style="padding: 0 50px;">{{$t('spinTips3')}}</div>
            <div class="jiang">1</div>
          </div>
          <div>
            <img src="static/images/buy-img.png" />
          </div>
          <div class="modal-footer ac">
            <button class="btn btn-yellow" id="closeModal" @click="confirm">{{$t('spinTips4')}}</button>
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import Header from '../components/HeaderTwo'
import Dialog from '../components/dialog'
import anime from "animejs";

export default {
  components: {
    Header,
    Dialog
  },
  name: "Lottery",
  data() {
    return {
      modalFoot: false,
      lotteryItems: [],
      wrapStyle: { transform: "rotate(45deg)" },
      isPlaying: false,
      animeInstance: null,
      jiang: '',
      pinNum: null,
      prizeList: [],
      isShow: false,
      num: 0
    };
  },
  created() {
    this.getList();
    this.getPinNum();
  },
  methods: {
    getUp() {
      this.isShow = !this.isShow;
    },
    getBuy() {
      let that = this;
      let data = {
        'token': localStorage.getItem('token'),
        answer_category_id: 1,
        uuid: localStorage.getItem('uuid')
      };

      that.$parent.loadModal(true);
      that.$api.post('/api/index/buy', data, r => {
        that.$parent.loadModal(false);
        if (r.code == 1) {
          that.$utils.alertText(that.$t('Purchasefailed'), 80);
          return;
        }
        that.$parent.returnCode(r, function() {
          that.$refs.buyDialog.showMaskFun();
          that.getPinNum();
        });
      });
    },
    back() {
      this.$router.go(-1);
    },
    getPinNum() {
      let that = this;
      let data = { 'token': localStorage.getItem('token'), uuid: localStorage.getItem('uuid') };
      that.$api.post('/api/prize/draw_num', data, r => {
        that.$parent.returnCode(r, function() {
          that.pinNum = r.data.draw_num;
        });
      });
    },
    confirm() {
      this.$refs.saveDialog.closeMask();
      this.$refs.buyDialog.closeMask();
    },
    getList() {
      let that = this;
      let data = { 'token': localStorage.getItem('token'), uuid: localStorage.getItem('uuid') };
      that.$api.post('/api/prize/list', data, r => {
        that.$parent.returnCode(r, function() {
          that.lotteryItems = r.data.prize;
        });
      });
      that.$api.post('/api/prize/win', data, r => {
        that.$parent.returnCode(r, function() {
          that.prizeList = r.data.list;
        });
      });
    },
    startLottery() {
      let that = this;
      if (this.isPlaying) return;

      let data = { 'token': localStorage.getItem('token'), uuid: localStorage.getItem('uuid') };
      that.$api.post('/api/prize/lottery', data, r => {
        if (r.code == 70001) {
          that.$utils.alertText(that.$t('nochance'), 80);
          return;
        }
        that.$parent.returnCode(r, function() {
          that.jiang = r.data.name;
          that.pinNum = r.data.draw_num;
          if (!that.animeInstance) {
            that.animeInstance = anime({
              targets: ".lottery-wrap",
              autoplay: false
            });
          }

          that.rotateTurntable(r.data.id - 2, () => {
            that.$refs.saveDialog.showMaskFun();
          });
        });
      });
    },
    rotateTurntable(index, callback) {
      this.num++;
      this.isPlaying = true;

      const total = this.lotteryItems.length;
      const angle = 360 / total;
      const rotateNum = 5;
      const offset = 0;
      let off = (total - index) * angle - angle / 2 - offset;
      // Reset animation if needed
      if (this.animeInstance) {
        this.animeInstance.seek(0);
      }
      this.animeInstance = anime({
        targets: ".lottery-wrap",
        easing: "easeInOutSine",
        duration: 3000,
        rotate: rotateNum * 360 + off,
        complete: () => {
          this.wrapStyle.transform = `rotate(${off}deg)`;
          this.isPlaying = false;
          if (callback && typeof callback === 'function') {
            callback();
          }
        }
      });
    }
  },
  mounted() {
    // Initialize anime.js instance
    this.animeInstance = anime({
      targets: ".lottery-wrap",
      autoplay: false
    });
  }
};
</script>

<style scoped>
/* 样式 */
.winlist{margin-top: 60px;}
.winlist-bg{background: #fff;border-radius: 20px;color:#440db1;margin: 0 20px;padding:20px;}
.prize-content{max-height: 200px;overflow: hidden;text-shadow: 0 0 #000;}
.win-title{background: #fe6d1a;padding:20px 20px;color:#fff;font-weight:700;border-radius: 20px;font-size:28px;margin-bottom: 10px;}
.up{margin: 20px 0;}
.spin-down{transform: rotate(180deg);}
.prize-list{justify-content:space-between;padding: 10px 0;}
.prize-list div{width: 33.33%;}
.bg{background: #0000008a;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: 100;}
.winlist-box.active .winlist-c{position: fixed;bottom: 0;z-index: 101;width: 100%;}
.active .prize-content{max-height: calc(100vh - 620px);overflow-y: scroll;}

.box-lottery {
  position: relative;
  margin: 0 auto;
  width: 641px;
  height: 641px;
  background: url('../../static/images/bg_lottery_f.png') center no-repeat;
  overflow: hidden;
}

.lottery-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  background: url('../../static/images/bg_lottery_f.png') center no-repeat;
}

.lottery-wrap img {
  width: 93px;
  height: 69px;
}

.lottery-wrap span {
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 32.7%;
  width: 126px;
  height: 50%;
  color: #fff;
  -webkit-transform-origin: 50% 100%;
  -moz-transform-origin: 50% 100%;
  -ms-transform-origin: 50% 100%;
  transform-origin: 50% 100%;
  text-align: center;
}

/* 每个奖品占据22.5度，调整旋转角度 */
.lottery-wrap span {
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 32.7%;
  width: 214px;
  height: 50%;
  color: #fff;
  -webkit-transform-origin: 50% 100%;
  -moz-transform-origin: 50% 100%;
  -ms-transform-origin: 50% 100%;
  transform-origin: 50% 100%;
  text-align: center;
}
.lottery-wrap span.lottery-span1 {
  -webkit-transform: rotate(22.5deg);
  -moz-transform: rotate(22.5deg);
  -ms-transform: rotate(22.5deg);
  transform: rotate(22.5deg);
}
.lottery-wrap span.lottery-span2 {
  -webkit-transform: rotate(67.5deg);
  -moz-transform: rotate(67.5deg);
  -ms-transform: rotate(67.5deg);
  transform: rotate(67.5deg);
}
.lottery-wrap span.lottery-span3 {
  -webkit-transform: rotate(112.5deg);
  -moz-transform: rotate(112.5deg);
  -ms-transform: rotate(112.5deg);
  transform: rotate(112.5deg);
}
.lottery-wrap span.lottery-span4 {
  -webkit-transform: rotate(157.5deg);
  -moz-transform: rotate(157.5deg);
  -ms-transform: rotate(157.5deg);
  transform: rotate(157.5deg);
}
.lottery-wrap span.lottery-span5 {
  -webkit-transform: rotate(202.5deg);
  -moz-transform: rotate(202.5deg);
  -ms-transform: rotate(202.5deg);
  transform: rotate(202.5deg);
}
.lottery-wrap span.lottery-span5 img {
  width: 71px;
  height: 71px;
}
.lottery-wrap span.lottery-span6 {
  -webkit-transform: rotate(247.5deg);
  -moz-transform: rotate(247.5deg);
  -ms-transform: rotate(247.5deg);
  transform: rotate(247.5deg);
}
.lottery-wrap span.lottery-span6 img {
  width: 80px;
  height: 55px;
}
.lottery-wrap span.lottery-span7 {
  -webkit-transform: rotate(292.5deg);
  -moz-transform: rotate(292.5deg);
  -ms-transform: rotate(292.5deg);
  transform: rotate(292.5deg);
}
.lottery-wrap span.lottery-span8 {
  -webkit-transform: rotate(337.5deg);
  -moz-transform: rotate(337.5deg);
  -ms-transform: rotate(337.5deg);
  transform: rotate(337.5deg);
}
/* 文字颜色循环：红、绿、蓝 */
.lottery-wrap span:nth-child(3n + 1) {
  color: #ff0000; /* 红色 */
}

.lottery-wrap span:nth-child(3n + 2) {
  color: #00ff00; /* 绿色 */
}

.lottery-wrap span:nth-child(3n + 3) {
  color: #0000ff; /* 蓝色 */
}

/* 其他样式保持不变 */
.lottery-wrap i {
  transform: rotate(263deg);
  display: block;
  width: 100%;
  /* height: 60px; */
  font-style: normal;
  font-size: 22px;
  line-height: 32px;
  color: #fee1e1;
  margin: 118px 0 12px;
  opacity: 0;
}

.lottery-wrap img {
  max-width: 100%;
}

.lottery-btn {
  position: absolute;
  left: 50%;
  top: 50%;
  /* text-indent: -999em; */
  z-index: 11;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 161px;
  height: 161px;
}

.box-lottery .jian {
  position: absolute;
  z-index: 20;
  top: -30px;
  left: 50%;
  margin-left: -20.5px;
  width: 60px;
  height: 102px;
  background: url('../../static/images/icon_point.png') center no-repeat;
  -webkit-transform-origin: 50% 102.5px;
  -moz-transform-origin: 50% 102.5px;
  -ms-transform-origin: 50% 102.5px;
  transform-origin: 50% 102.5px;
}

.lottery-btn:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url('../../static/images/btn_lottery.png') center no-repeat;
}

.spin-c{
  background: url('../../static/images/tan.png') center no-repeat;
  width: 647px;
  height: 891px;border-radius: 110px;}
.gx{text-shadow: 1px 3px 0px #000;font-size: 20px;color:#fff}
.jiang{border:4px solid #fff;display: inline-block;padding:5px 30px;border-radius: 120px;margin: 20px 0;position: relative;}
.jiang::after {
  content:'';
  width: 0;
  height: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-top: 24px solid #fff;
  bottom: -26px;
  position: absolute;
  margin-left: -16px;
  left: 50%;
}
.buypin{
  width: 349px;
  height:108px;
  background: url('../../static/images/buypin.png') center no-repeat;
  font-size: 30px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    margin:20px auto;}
.spin-content{
  background: url('../../static/images/spin-bg.png') center no-repeat;}
</style>



// WEBPACK FOOTER //
// src/page/spin.vue